import React from 'react';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  children: React.ReactNode;
}

interface CardHeaderProps {
  className?: string;
  children: React.ReactNode;
}

interface CardContentProps {
  className?: string;
  children: React.ReactNode;
}

interface CardFooterProps {
  className?: string;
  children: React.ReactNode;
}

export const Card: React.FC<CardProps> = ({ className = '', children, id, style, tabIndex, onClick }) => (
  <div
    role="button"
    className={`bg-card border border-border rounded-lg shadow-sm ${className}`}
    id={id}
    style={style}
    tabIndex={tabIndex}
    onClick={onClick}
    // 필요하다면 다른 prop도 추가
  >
    {children}
  </div>
);

export const CardHeader: React.FC<CardHeaderProps> = ({ className = '', children }) => (
  <div className={`p-6 pb-2 ${className}`}>{children}</div>
);

export const CardTitle: React.FC<CardHeaderProps> = ({ className = '', children }) => (
  <div className={`text-2xl font-semibold leading-none tracking-tight ${className}`}>{children}</div>
);

export const CardContent: React.FC<CardContentProps> = ({ className = '', children }) => (
  <div className={`p-6 pt-0 ${className}`}>{children}</div>
);

export const CardFooter: React.FC<CardFooterProps> = ({ className = '', children }) => (
  <div className={`p-6 pt-0 flex items-center ${className}`}>{children}</div>
);
